import { render, staticRenderFns } from "./courseForm.vue?vue&type=template&id=68f0f676&scoped=true"
import script from "./courseForm.vue?vue&type=script&lang=js"
export * from "./courseForm.vue?vue&type=script&lang=js"
import style0 from "./courseForm.vue?vue&type=style&index=0&id=68f0f676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0f676",
  null
  
)

export default component.exports